import { render, staticRenderFns } from "./DsSelect.vue?vue&type=template&id=20f84e84"
import script from "./DsSelect.vue?vue&type=script&lang=js"
export * from "./DsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports